import Box from "@mui/material/Box";
import SolutionList from "./SolutionList";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../common/ErrorFallback";

function SolutionListContainer() {
  return (
    <Box
      data-testid="solution-list-page-container-outer"
      sx={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        data-testid="solution-list-page-container-inner"
        sx={{
          m: 6,
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <SolutionList />
        </ErrorBoundary>
      </Box>
    </Box>
  );
}

export default SolutionListContainer;
